<template>
    <div>
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="Buybox价格趋势" name="view1">
                <view1 ref="view1"></view1>
            </el-tab-pane>
            <el-tab-pane label="评论趋势" name="view2">
                <view2 ref="view2"></view2>
            </el-tab-pane>
            <el-tab-pane label="不同星级评论趋势" name="view3">
                <view3 ref="view3"></view3>
            </el-tab-pane>
            <el-tab-pane label="评分趋势" name="view4">
                <view4 ref="view4"></view4>
            </el-tab-pane>
            <el-tab-pane label="星级趋势" name="view5">
                <view5 ref="view5"></view5>
            </el-tab-pane>
            <el-tab-pane label="卖家数趋势" name="view6">
                <view6 ref="view6"></view6>
            </el-tab-pane>
            <el-tab-pane label="问答数趋势" name="view7">
                <view7 ref="view7"></view7>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import View1 from "./view1";
import View2 from "./view2";
import View3 from "./view3";
import View4 from "./view4";
import view5 from "./view5";
import View6 from "./view6";
import View7 from "./view7";
export default {
    components: {
        View1,
        View2,
        View3,
        View4,
        view5,
        View6,
        View7
    },
    data() {
        return {
            activeName: "view1"
        };
    },
    mounted() {
        let that = this;
        let oneDay = 24 * 3600 * 1000;
        let base = +new Date(2018, 9, 3);
        let date = [];
        let data = [];
        for (let i = 1; i < 200; i++) {
            let now = new Date((base += oneDay));
            date.push([
                [now.getFullYear(), now.getMonth() + 1, now.getDate()].join("-")
            ]);
            data.push(Math.floor(Math.random() * (1 - 17) + 17));
        }
        setTimeout(function() {
            that.$refs.view1.getData(date, data);
        }, 10);
    },
    methods: {
        screenWidth() {
            this.$refs[this.activeName].screenWidth();
        },
        handleClick(tab) {
            let that = this;
            if (tab.paneName == "view1") {
                setTimeout(function() {
                    that.$refs.view1.getData();
                }, 10);
            } else if (tab.paneName == "view2") {
                let oneDay = 24 * 3600 * 1000;
                let base = +new Date(2018, 9, 3);
                let date = [];
                let data = [];
                let data1 = [];
                for (let i = 1; i < 200; i++) {
                    let now = new Date((base += oneDay));
                    date.push([
                        [
                            now.getFullYear(),
                            now.getMonth() + 1,
                            now.getDate()
                        ].join("-")
                    ]);
                    data.push(Math.floor(Math.random() * (170 - 178) + 178));
                    data1.push(Math.floor(Math.random() * (160 - 165) + 165));
                }
                setTimeout(function() {
                    that.$refs.view2.getData(date, data, data1);
                }, 10);
            } else if (tab.paneName == "view3") {
                let oneDay = 24 * 3600 * 1000;
                let base = +new Date(2018, 9, 3);
                let date = [];
                let data1 = [];
                let data2 = [];
                let data3 = [];
                let data4 = [];
                let data5 = [];
                for (let i = 1; i < 200; i++) {
                    let now = new Date((base += oneDay));
                    date.push([
                        [
                            now.getFullYear(),
                            now.getMonth() + 1,
                            now.getDate()
                        ].join("-")
                    ]);
                    data1.push(Math.floor(Math.random() * (45 - 50) + 50));
                    data2.push(Math.floor(Math.random() * (17 - 20) + 20));
                    data3.push(Math.floor(Math.random() * (10 - 14) + 14));
                    data4.push(Math.floor(Math.random() * (17 - 20) + 20));
                    data5.push(Math.floor(Math.random() * (80 - 96) + 96));
                }
                let obj = {
                    data1: data1,
                    data2: data2,
                    data3: data3,
                    data4: data4,
                    data5: data5
                };
                setTimeout(function() {
                    that.$refs.view3.getData(date, obj);
                }, 10);
            } else if (tab.paneName == "view4") {
                let that = this;
                let oneDay = 24 * 3600 * 1000;
                let base = +new Date(2018, 9, 3);
                let date = [];
                let data = [];
                for (let i = 1; i < 200; i++) {
                    let now = new Date((base += oneDay));
                    date.push([
                        [
                            now.getFullYear(),
                            now.getMonth() + 1,
                            now.getDate()
                        ].join("-")
                    ]);
                    data.push(Math.floor(Math.random() * (0 - 6) + 6));
                }
                setTimeout(function() {
                    that.$refs.view4.getData(date, data);
                }, 10);
            } else if (tab.paneName == "view5") {
                let that = this;
                let oneDay = 24 * 3600 * 1000;
                let base = +new Date(2018, 9, 3);
                let date = [];
                let data = [];
                for (let i = 1; i < 200; i++) {
                    let now = new Date((base += oneDay));
                    date.push([
                        [
                            now.getFullYear(),
                            now.getMonth() + 1,
                            now.getDate()
                        ].join("-")
                    ]);
                    data.push(Math.floor(Math.random() * (0 - 6) + 6));
                }
                setTimeout(function() {
                    that.$refs.view5.getData(date, data);
                }, 10);
            } else if (tab.paneName == "view6") {
                let that = this;
                let oneDay = 24 * 3600 * 1000;
                let base = +new Date(2018, 9, 3);
                let date = [];
                let data = [];
                for (let i = 1; i < 200; i++) {
                    let now = new Date((base += oneDay));
                    date.push([
                        [
                            now.getFullYear(),
                            now.getMonth() + 1,
                            now.getDate()
                        ].join("-")
                    ]);
                    data.push(Math.floor(Math.random() * (0 - 3) + 3));
                }
                setTimeout(function() {
                    that.$refs.view6.getData(date, data);
                }, 10);
            } else if (tab.paneName == "view7") {
                let that = this;
                let oneDay = 24 * 3600 * 1000;
                let base = +new Date(2018, 9, 3);
                let date = [];
                let data = [];
                for (let i = 1; i < 200; i++) {
                    let now = new Date((base += oneDay));
                    date.push([
                        [
                            now.getFullYear(),
                            now.getMonth() + 1,
                            now.getDate()
                        ].join("-")
                    ]);
                    data.push(Math.floor(Math.random() * (15 - 18) + 18));
                }
                setTimeout(function() {
                    that.$refs.view7.getData(date, data);
                }, 10);
            }
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
